const defaultFontSizes = {
    ['Display']: null,
    ['Headline']: null,
    ['Title']: null,
    ['Subheader']: null,
    ['Body']: null,
    ['Caption']: null,
    ['Small']: null,
};
const defaultFontLineHeights = {
    ['Display']: null,
    ['Headline']: null,
    ['Title']: null,
    ['Subheader']: null,
    ['Body']: null,
    ['Caption']: null,
    ['Small']: null,
};
export const defaultFontConfiguration = {
    family: '',
    sizes: defaultFontSizes,
    lineHeights: defaultFontLineHeights,
    fontWeight: '',
    italic: '',
    emphasized: '',
};
// New look
export const BaseFontConfiguration = {
    family: 'Matter, "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
    sizes: {
        ['Display']: '40px',
        ['Headline']: '32px',
        ['Title']: '24px',
        ['Subheader']: '20px',
        ['Body']: '16px',
        ['Caption']: '14px',
        ['Small']: '12px',
    },
    lineHeights: {
        ['Display']: '48px',
        ['Headline']: '40px',
        ['Title']: '32px',
        ['Subheader']: '28px',
        ['Body']: '24px',
        ['Caption']: '22px',
        ['Small']: '22px',
    },
    fontWeight: 'normal',
    italic: 'font-style: italic',
    emphasized: 'font-weight: 500',
};
